import React, { memo, forwardRef } from "react";
const SvgNaturalLogarithm = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M10.964 11.648c0-.196.028-.355.084-.476a.84.84 0 01.224-.294.742.742 0 01.28-.126.886.886 0 01.252-.042c.065 0 .144.014.238.042.103.019.196.06.28.126a.668.668 0 01.224.294c.065.121.098.28.098.476v8.96c0 .196-.033.36-.098.49a.68.68 0 01-.224.28.636.636 0 01-.28.126.854.854 0 01-.238.042.886.886 0 01-.252-.042.745.745 0 01-.28-.126.87.87 0 01-.224-.28 1.248 1.248 0 01-.084-.49v-8.96zM14.682 15.456c0-.187.028-.336.084-.448a.72.72 0 01.224-.266.638.638 0 01.252-.126.852.852 0 01.238-.042.72.72 0 01.224.042c.093.019.182.06.266.126a.62.62 0 01.21.266.886.886 0 01.098.448v.322h.028c.15-.336.406-.63.77-.882.373-.261.812-.392 1.316-.392.439 0 .812.08 1.12.238.317.15.574.35.77.602.205.252.355.541.448.868.093.327.14.663.14 1.008v3.388c0 .196-.033.36-.098.49a.68.68 0 01-.224.28.636.636 0 01-.28.126.854.854 0 01-.238.042.886.886 0 01-.252-.042.745.745 0 01-.28-.126.87.87 0 01-.224-.28 1.248 1.248 0 01-.084-.49v-2.912c0-.196-.014-.401-.042-.616a1.596 1.596 0 00-.182-.574 1.168 1.168 0 00-.392-.434c-.159-.112-.373-.168-.644-.168-.27 0-.504.056-.7.168-.196.103-.36.238-.49.406a1.904 1.904 0 00-.28.588 2.245 2.245 0 00-.098.658v2.884c0 .196-.033.36-.098.49a.68.68 0 01-.224.28.636.636 0 01-.28.126.854.854 0 01-.238.042.886.886 0 01-.252-.042.745.745 0 01-.28-.126.87.87 0 01-.224-.28 1.248 1.248 0 01-.084-.49v-5.152z"
      />
    </svg>
  );
});
SvgNaturalLogarithm.displayName = "SvgNaturalLogarithm";
const MemoForwardRef = memo(SvgNaturalLogarithm);
export default MemoForwardRef;
